<template>
  <v-ons-page class="l-content">
    <custom-toolbar backLabel="Retour">{{ $t("Parrainage") }}</custom-toolbar>

    <div class="container">
      <form>
        <p>
          <label for="">{{ $t("Titre") }}</label>
          <br>
          <v-ons-select class="select" modifier="material" v-model="friend.pro_fk_genre" required>
            <option value="1">{{ $t("Monsieur") }}</option>
            <option value="2">{{ $t("Madame") }}</option>
          </v-ons-select>
        </p>
        <p>
          <label for="">{{ $t("Prénom de l'ami") }}</label>
          <v-ons-input type="text" modifier="material" v-model="friend.pro_fName" required></v-ons-input>
        </p>
        <p>
          <label for="">{{ $t("Nom de l'ami") }}</label>
          <v-ons-input type="text" modifier="material" v-model="friend.pro_lName" required></v-ons-input>
        </p>
        <p>
          <label for="">{{ $t("Email de l'ami") }}</label>
          <v-ons-input type="email" modifier="material" v-model="friend.pro_email" required></v-ons-input>
        </p>
        <p>
          <label for="">{{ $t("Téléphone de l'ami") }}</label>
          <v-ons-input type="text" modifier="material" v-model="friend.pro_tel" required></v-ons-input>
        </p>
        <v-ons-button @click="sponsor">{{ $t("Envoyer") }}</v-ons-button>
      </form>
    </div>
  </v-ons-page>
</template>

<script>
  export default {
    data () {
      return {
        friend: {
          pro_fk_genre: null,
          pro_fName: null,
          pro_lName: null,
          pro_email: null,
          pro_tel: null,
          pro_active: 1,
          pro_fk_prospect_source: 7
        }
      };
    },
    methods: {
      sponsor() {
        this.friend.pro_fk_prospect_sponsor = loggedIn.pro_id;
        var form = this.$el.querySelector('form');
        form.reportValidity();

        if(form.checkValidity()) {
          self = this;
          axios
            .get('/users/save', {
              params: {
                'x-secundo-auth': 'ABC123',
                'user': JSON.stringify(this.friend)
              }
            })
            .then(response => {
              this.$ons.notification.toast(self.$i18n.t('Parrainage enregistré !'), {timeout: 5000})
              this.$store.commit('navigator/pop');
            });
        }
      }
    }
  };
</script>


// WEBPACK FOOTER //
// SponsorshipForm.vue?5ec14c4b